import Image from "next/image";

const InnerContent = ({ imgUrl, imgAlt, head, copy }) => {
  return (
    <div className="row">
      <Image src={imgUrl} alt={imgAlt} width={84} height={84} />
      <div className="copy">
        <h5 className="heading body--xl">{head}</h5>
        <h6 className="body--lg">{copy}</h6>
      </div>
    </div>
  );
};

const Enhance = ({ head, subhead, blocks }) => {
  return (
    <section className="enhance full">
      <div className="enhance__banner banner">
        <div className="enhance__copy">
          <div className="section-header">
            <h2 className="heading heading--lg"> {head} </h2>
          </div>
          <h5 className="heading heading--xs"> {subhead} </h5>
          <div className="rows">
            {blocks.map((block, index) => (
              <InnerContent key={index} {...block} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Enhance;
